import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { PERSISTENCY_MODULE_CONFIG } from '../persistency-module-config';

@Injectable({
  providedIn: 'root',
})
export class DocumentsPersistency {
  private http = inject(HttpClient);
  private config = inject(PERSISTENCY_MODULE_CONFIG);

  private url = `${this.config.apiBaseUrl}/api/admin/backofficeTenderForms`;
  saveCompiledDocument: any;

  uploadAttachment(file: File, documentId: string, uniqueId: string) {
    const formData = new FormData();
    formData.append('Name', file.name);
    formData.append('file', file);
    formData.append('ContentType', file.type);
    formData.append('ContentDisposition', 'attachment');
    formData.append('Headers', '');
    formData.append('Length', file.size.toString());

    return this.http.post(
      `${this.url}/uploadAttachment/${documentId}?uniqueId=${uniqueId}`,
      formData,
      {
        responseType: 'text',
      },
    );
  }

  deleteAttachment(documentId: string, fileId: string) {
    return this.http.delete(
      `${this.url}/removeAttachment/${documentId}?fileId=${fileId}`,
    );
  }
}
